import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { levelsNestedRoutes } from "@/modules/router/routings/authenticatedRouting";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createLevelsNavStyles } from "./createLevelsNavStyles";

const translationNamespace = "pages/LevelsPage";

export const LevelsNav = () => {
  const { t } = useTranslation(translationNamespace);
  const classes = createLevelsNavStyles(useTheme());

  return (
    <ul className={classes.root}>
      <li className={classes.listElement}>
        <NavLink
          className={classes.navigationLink}
          activeClassName={classes.linkActive}
          exact
          to={levelsNestedRoutes.buildUrl("levels")}
        >
          {t("Levels")}
        </NavLink>
      </li>
      <li className={classes.listElement}>
        <NavLink
          className={classes.navigationLink}
          activeClassName={classes.linkActive}
          exact
          to={levelsNestedRoutes.buildUrl("ranking")}
        >
          {t("Ranking")}
        </NavLink>
      </li>
    </ul>
  );
};
